<template>
  <div class="page">
    <div class="box" v-if="!autoChecking">
      <div class="title">尊享礼品提货中心</div>
      <div class="sub-title">请验证您的兑换卡密</div>
      <input type="text" v-model="cardno" placeholder="输入卡号">
      <input type="password" v-model="pwd" placeholder="输入卡密">
      <button @click="checkCard" :disabled="checking">{{ checking ? '验证中...' : '立即验证' }}</button>
    </div>

    <div class="box checking-box" v-else>
      <div class="title">正在进入...</div>
      <div class="sub-title">请稍候</div>
    </div>

    <Modal :visible="modal.visible" :title="modal.title" @close="modal.visible = false">
      <p>{{ modal.msg }}</p>
      <template #footer>
        <button class="modal-btn" @click="modal.visible = false">确定</button>
      </template>
    </Modal>
  </div>
</template>

<script>
import Modal from '@/components/Modal.vue';
import { getTheme } from '@/utils/theme';
import { saveCardSession, getCardSession, tryEnterLogistics } from '@/utils/cardSession';

export default {
  name: 'CardVerifyPage',
  components: { Modal },
  data() {
    return {
      cardno: '',
      pwd: '',
      checking: false,
      autoChecking: true,
      modal: { visible: false, title: '', msg: '' }
    };
  },
  async created() {
    const saved = getCardSession();
    if (saved) {
      this.cardno = saved.cardNo;
      this.pwd = saved.cardKey;
    }
    const entered = await tryEnterLogistics(this.$router);
    this.autoChecking = false;
    if (entered) return;
  },
  methods: {
    showModal(title, msg) {
      this.modal = { visible: true, title, msg };
    },
    async checkCard() {
      const c = this.cardno.trim();
      const p = this.pwd.trim();
      if (!c) return this.showModal('提示', '请输入卡号');
      if (!p) return this.showModal('提示', '请输入卡密');
      if (c.length !== 18) return this.showModal('提示', '卡号必须为18位');
      if (p.length !== 8) return this.showModal('提示', '卡密必须为8位');
      this.checking = true;
      try {
        const site = getTheme();
        const res = await fetch('/api/verify-card', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ cardNo: c, cardKey: p, site })
        });
        const data = await res.json();
        if (data.code === 200) {
          const d = data.data;
          sessionStorage.setItem('site', site);
          if (d.status === 'active') {
            saveCardSession(c, p);
            sessionStorage.setItem('cardInfo', JSON.stringify(d));
            this.$router.push('/logistics?cardNo=' + d.cardNo);
          } else {
            sessionStorage.setItem('card', c);
            sessionStorage.setItem('cardKey', p);
            this.$router.push('/package');
          }
        } else {
          this.showModal('验证失败', data.message || '卡号或卡密不正确');
        }
      } catch {
        this.showModal('提示', '网络错误，请稍后重试');
      } finally {
        this.checking = false;
      }
    }
  }
};
</script>

<style scoped>
.page {
  min-height: 100vh;
  padding: 20px 15px;
}
.box {
  max-width: 420px;
  margin: 0 auto;
  background: #fff;
  padding: 25px 20px;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.06);
  border-top: 5px solid var(--color-primary);
}
.title {
  text-align: center;
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 20px;
  color: #1a1a1a;
  letter-spacing: 1px;
}
.sub-title {
  font-size: 15px;
  color: #666;
  margin-bottom: 15px;
  text-align: center;
}
input {
  width: 100%;
  box-sizing: border-box;
  padding: 14px 16px;
  margin: 8px 0;
  border: 1px solid #eaeaea;
  background-color: #fafbfc;
  border-radius: 10px;
  font-size: 15px;
  color: #333;
  transition: all 0.3s ease;
  outline: none;
}
input:focus {
  border-color: var(--color-primary-light);
  background-color: #fff;
  box-shadow: 0 0 0 3px rgba(var(--color-primary-rgb), 0.1);
}
button {
  width: 100%;
  padding: 14px;
  background: linear-gradient(135deg, var(--color-primary-light), var(--color-primary));
  color: #fff;
  border: none;
  border-radius: 10px;
  font-size: 17px;
  font-weight: 600;
  margin-top: 15px;
  cursor: pointer;
  box-shadow: 0 4px 15px var(--color-primary-shadow);
  transition: all 0.2s ease;
}
button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px var(--color-primary-shadow-hover);
}
.modal-btn {
  width: auto;
  padding: 10px 32px;
  margin-top: 0;
}
</style>
